@use "sass:color";
@use "foundation/colors";
@use "foundation/mixins";

.author-info-container {
  button.complete-with-ai {
    align-items: center;
    background-color: colors.$secondary-tangerine;
    border-radius: mixins.em(4.5px);
    padding: 0.67em 1em;
    line-height: normal;
    font-size: 12px;

    &:hover {
      background-color: color.adjust(colors.$secondary-tangerine, $lightness: 5%);
    }

    &:disabled {
      opacity: 0.5;
    }

    span {
      display: flex;
      margin-right: mixins.em(8px);

      svg {
        height: 20px;
      }
    }
  }
}
